var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-MIC"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIC",
    clipPath: "url(#clip-MIC)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mic-2",
    "data-name": "mic",
    transform: "translate(64.233 64.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M348.476,64.279A64.258,64.258,0,0,0,243.309,14.7c4.969,16.941,14.627,33.927,28.717,48.7,18.767,19.641,42.9,32.382,66.291,35.434A63.754,63.754,0,0,0,348.476,64.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M266.356,68.833a128.667,128.667,0,0,1-29.271-48.165A63.834,63.834,0,0,0,221.2,52.18c6.071,17.232,16.956,33.656,31.69,47.364a121.6,121.6,0,0,0,46.09,27.216,64.1,64.1,0,0,0,34.188-20.9C309.332,101.687,285.226,88.592,266.356,68.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M118.311,340.647c-12.066,10.015-51.748,7.069-73.949,2.886a7.849,7.849,0,0,0-2.914,15.425A254.483,254.483,0,0,0,84.8,363.142c16.584,0,33.8-2.328,43.528-10.4a23.241,23.241,0,0,0,8.725-18.454c0-21.027-12.822-30.949-23.121-38.96-9.748-7.559-15.747-12.724-16.164-23.243-.519-13.369,4.695-22.378,9.69-27.912,11.664,10.331,34.1,7.947,50.594-5.614l23.612-19.38a21.391,21.391,0,0,0,12.389,7.774V349.833c-35.971,1.286-63.492,8.279-63.492,16.743,0,9.369,33.685,16.959,75.268,16.959s75.268-7.59,75.268-16.959c0-8.464-27.523-15.457-63.494-16.743V215.471a20.911,20.911,0,0,0-2.881-23.411l73.973-60.692a131.537,131.537,0,0,1-41.152-26.077,130.2,130.2,0,0,1-30.5-42.36L156.983,136.8a15.673,15.673,0,0,0-19.02,23.4l-27.154,33.394c-9.123,11.226-12.8,24.9-10.922,36.035-8.157,7.249-18.659,20.959-17.805,43.067.725,18.37,12.635,27.607,22.217,35.037,9.521,7.39,17.054,13.232,17.054,26.554A7.552,7.552,0,0,1,118.311,340.647Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/MIC.a23dbe05234742299bd4117e146e9943.svg";
export { ForwardRef as ReactComponent };